import { Personnel } from '../../personnel/types';
import type { PermissionValue, ProjectMember, Role } from '../types';
import { getRoleById, hasPermission } from '../permissions';

/**
 * Auto-link a user to a Personnel based on email match
 * Returns the suggested role based on Personnel type
 */
export function autoLinkUser(
    email: string,
    castMembers: Personnel[]
): { Personnel: Personnel; suggestedRoleId: string } | null {
    const match = castMembers.find(
        member => member.email?.toLowerCase() === email.toLowerCase() && !member.deleted
    );

    if (!match) return null;

    // Determine role based on member category
    let suggestedRoleId: string;
    switch (match.category) {
        case 'cast':
            suggestedRoleId = 'cast';
            break;
        case 'crew':
            suggestedRoleId = 'crew';
            break;
        case 'production':
            suggestedRoleId = 'stage-manager';
            break;
        default:
            suggestedRoleId = 'crew';
    }

    return { Personnel: match, suggestedRoleId };
}

/**
 * Create a ProjectMember for a new user
 */
export function createProjectMember(
    userId: string,
    roleId: string,
    personnelId?: string
): ProjectMember {
    return {
        userId,
        roleId,
        personnelId,
        status: 'active',
        joinedAt: Date.now(),
    };
}

/**
 * Create a pending ProjectMember (awaiting approval)
 */
export function createPendingMember(userId: string): ProjectMember {
    return {
        userId,
        roleId: 'pending',
        status: 'pending',
        joinedAt: Date.now(),
    };
}

/**
 * Check if a user has a specific permission
 */
export function userHasPermission(
    member: ProjectMember | null | undefined,
    roles: Role[],
    permission: PermissionValue
): boolean {
    if (!member || member.status !== 'active') return false;
    
    const role = getRoleById(roles, member.roleId);
    if (!role) return false;
    
    return hasPermission(role, permission);
}














